import React from "react";
import PropTypes from "prop-types";
const DesignSizeIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-2-2h24v24H-2z" />
      <g fill={color || "var(--color-easil-gray-x-dark)"} fillRule="nonzero">
        <path d="M14.7 18H17a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-.922V8H17a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-2.575l.276-2zm0 0H17a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-.922V8H17a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-2.575l.276-2z" />
        <path d="M9.729 18H14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1.028V4H14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H9.266l.463-2zm0 0H14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1.028V4H14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H9.266l.463-2z" />
        <path d="M3 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3zm0-2h8a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z" />
        <path d="M5 8h4-4zm0-1h4a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2zM5 12h1-1zm0-1h1a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2z" />
      </g>
    </g>
  </svg>
);
DesignSizeIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default DesignSizeIcon;
